
import React, { useEffect, useRef, useState, useMemo } from 'react';
import './TratamientoScreen.css';
// Eliminado WebXR: usamos solo inmersivo 180° sin XR

// Recibe tratamientoId como prop




export default function TratamientoScreen({ tratamientoId, token, userId, onFinish, onRelax, onNotas }) {
  // Forzar orientación landscape y pantalla completa al montar
  useEffect(() => {
    document.body.classList.add('force-landscape');
    // Intentar pantalla completa y luego bloquear orientación, ambos con control de errores
    (async () => {
      try {
        const el = document.documentElement;
        if (el.requestFullscreen) {
          try { await el.requestFullscreen(); } catch (e) { /* sin gesto del usuario: permitido fallar */ }
        } else if (el.webkitRequestFullscreen) {
          try { el.webkitRequestFullscreen(); } catch (e) {}
        } else if (el.mozRequestFullScreen) {
          try { el.mozRequestFullScreen(); } catch (e) {}
        } else if (el.msRequestFullscreen) {
          try { el.msRequestFullscreen(); } catch (e) {}
        }
        // Bloquear orientación solo si ya estamos en fullscreen y el API existe
        try {
          const isFs = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
          if (isFs && window.screen && window.screen.orientation && window.screen.orientation.lock) {
            await window.screen.orientation.lock('landscape');
          }
        } catch (err) {
          // Algunos navegadores requieren gesto del usuario o HTTPS
          console.warn('orientation.lock skipped', err);
        }
      } catch (_) {}
    })();
    return () => {
      document.body.classList.remove('force-landscape');
      // Intentar desbloquear orientación de forma segura
      try {
        if (window.screen && window.screen.orientation && window.screen.orientation.unlock) {
          window.screen.orientation.unlock();
        }
      } catch (err) {
        // Puede lanzar 'Permissions check failed' en algunos navegadores; ignoramos
        console.warn('orientation.unlock failed', err);
      }
      // Salir de pantalla completa solo si estamos en fullscreen
      try {
        const isFs = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        if (isFs) {
          if (document.exitFullscreen) {
            document.exitFullscreen().catch(e => console.warn('exitFullscreen failed', e));
          } else if (document.webkitExitFullscreen) {
            try { document.webkitExitFullscreen(); } catch (e) { console.warn('webkitExitFullscreen failed', e); }
          } else if (document.mozCancelFullScreen) {
            try { document.mozCancelFullScreen(); } catch (e) { console.warn('mozCancelFullScreen failed', e); }
          } else if (document.msExitFullscreen) {
            try { document.msExitFullscreen(); } catch (e) { console.warn('msExitFullscreen failed', e); }
          }
        }
      } catch (err) {
        console.warn('Error while attempting to exit fullscreen', err);
      }
    };
  }, []);
  // Declarar primero todos los useState
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [datos, setDatos] = useState(null);
  const [palabrasTxt, setPalabrasTxt] = useState(null);
  // Leer progreso guardado en localStorage solo al montar
  const getInitialProgress = () => {
    const key = `progreso_tratamiento_${userId}_${tratamientoId}`;
    const saved = localStorage.getItem(key);
    if (!saved) return { imgIdx: 0, finished: false };
    try {
      const obj = JSON.parse(saved);
      if (obj && typeof obj.imgIdx === 'number') {
        return { imgIdx: obj.finished ? 0 : obj.imgIdx, finished: false };
      }
    } catch {}
    return { imgIdx: 0, finished: false };
  };
  const initialProgress = getInitialProgress();
  const [imgIdx, setImgIdx] = useState(initialProgress.imgIdx);
  const [showImg, setShowImg] = useState(true);
  const [blinkCount, setBlinkCount] = useState(0);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [finished, setFinished] = useState(initialProgress.finished);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const intervalRef = useRef();

  // Luego el useMemo que depende de datos
  const {
    nombreCarpeta,
    frameRate,
    frameMs,
    imagenes,
    audio,
    emdrGif,
    logotema,
    palabrasList
  } = useMemo(() => {
    if (!datos) {
      return {
        nombreCarpeta: 'fobia-alturas',
        frameRate: 6,
        frameMs: 10000,
        imagenes: [],
        audio: '',
        emdrGif: '',
        logotema: '',
        palabrasList: []
      };
    }
  // Forzar mayúsculas para coincidir con la carpeta real (INSOMNIO)
  const nombreCarpeta = (datos.carpeta || datos.nombreCarpeta || 'fobia-alturas').toUpperCase();
    const frameRate = datos.frameRate || 6;
    const imagenesPorSerie = 7;
    const cantidadImagenes = datos.cantidadImagenes || 14;
    const cantidadSeries = Math.ceil(cantidadImagenes / imagenesPorSerie);
    const frameMs = 1000 * (datos.segundosPorImagen || 10);
    const imagenes = [];
    let imgCount = 0;
    for (let serie = 1; serie <= cantidadSeries; serie++) {
      for (let img = 1; img <= imagenesPorSerie; img++) {
        imgCount++;
        if (imgCount > cantidadImagenes) break;
        imagenes.push(`/Tratamientos/${nombreCarpeta}/${serie}-${img}.jpg`);
      }
    }
    // Palabras: cargar desde palabras.txt si existe, si no, usar array vacío
    let palabrasList = [];
    if (palabrasTxt && typeof palabrasTxt === 'string') {
      palabrasList = palabrasTxt.split(',').map(p => p.trim()).slice(0, imagenes.length);
      if (palabrasList.length < imagenes.length) {
        palabrasList = [...palabrasList, ...Array(imagenes.length - palabrasList.length).fill('')];
      }
    } else if (Array.isArray(datos.palabras)) {
      palabrasList = datos.palabras.slice(0, imagenes.length);
      if (palabrasList.length < imagenes.length) {
        palabrasList = [...palabrasList, ...Array(imagenes.length - palabrasList.length).fill('')];
      }
    } else {
      palabrasList = Array(imagenes.length).fill('');
    }
    const audio = `/Tratamientos/${nombreCarpeta}/audio.mp3`;
    const emdrGif = `/Tratamientos/${nombreCarpeta}/emdr.gif`;
    const logotema = `/Tratamientos/${nombreCarpeta}/logotema.png`;
    return { nombreCarpeta, frameRate, frameMs, imagenes, audio, emdrGif, logotema, palabrasList };
  }, [datos, palabrasTxt]);

  // Cargar palabras.txt si hay carpeta
  useEffect(() => {
    if (!datos) return;
  const carpeta = (datos.carpeta || datos.nombreCarpeta || '').toUpperCase();
    if (!carpeta) return;
    fetch(`/Tratamientos/${carpeta}/palabras.txt`)
      .then(res => res.ok ? res.text() : '')
      .then(txt => {
        setPalabrasTxt(txt);
      })
      .catch(() => setPalabrasTxt(''));
  }, [datos]);

  useEffect(() => {
    setLoading(true);
    setError(null);
      fetch(`https://api.braineka.com/usuarios/${userId}/tratamientos`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(tratamientos => {
        console.log('Tratamientos recibidos:', tratamientos);
        const found = tratamientos.find(t => String(t.id) === String(tratamientoId));
        if (!found) {
          setError('Tratamiento no encontrado');
          console.error('Tratamiento no encontrado:', tratamientoId);
        } else {
          setDatos(found);
          console.log('Tratamiento datos:', found);
          if (found.carpeta && found.carpeta.toUpperCase() === 'INSOMNIO') {
            console.log('Tratamiento INSOMNIO detectado:', found);
          }
        }
      })
      .catch(e => {
        setError(e.message);
        console.error('Error cargando tratamientos:', e);
      })
      .finally(() => setLoading(false));
  }, [tratamientoId, token, userId]);

  // Parpadeo de la imagen según frameRate
  useEffect(() => {
    if (!datos || typeof frameRate !== 'number' || isNaN(frameRate) || frameRate <= 0) return;
    let blinkInterval;
    setShowImg(true); // Siempre inicia mostrando la imagen
    const fr = frameRate;
    let blinkState = true;
    blinkInterval = setInterval(() => {
      blinkState = !blinkState;
      setShowImg(blinkState);
    }, 1000 / (fr * 2)); // alterna visible/negro, así que *2
    return () => clearInterval(blinkInterval);
  }, [imgIdx, frameRate, datos]);

  // Guardar progreso en localStorage cada vez que cambia imgIdx o finished
  useEffect(() => {
    if (!userId || !tratamientoId) return;
    const key = `progreso_tratamiento_${userId}_${tratamientoId}`;
    // Si terminó, guardar como terminado y resetear imgIdx a 0
    if (finished) {
      localStorage.setItem(key, JSON.stringify({ imgIdx: 0, finished: true }));
    } else {
      localStorage.setItem(key, JSON.stringify({ imgIdx, finished: false }));
    }
  }, [imgIdx, finished, userId, tratamientoId]);

  // Mostrar cada imagen al menos frameMs (mínimo 10s), si solo hay una imagen, parpadear y finalizar tras frameMs
  useEffect(() => {
    if (!datos || loading || !frameMs || finished) return;
    if (imagenes.length === 1) {
      // Solo una imagen: parpadear durante frameMs y finalizar
      const timer = setTimeout(() => {
        setFinished(true);
      }, frameMs);
      return () => clearTimeout(timer);
    }
    // Si toca pausa, mostrar modal y no avanzar automáticamente
    if ((imgIdx + 1) % imagenesPorSerie === 0 && imgIdx + 1 < imagenes.length) {
      // Esperar los 10s y luego pausar (no avanzar automáticamente)
      const timer = setTimeout(() => {
        setShowPauseModal(true);
      }, frameMs);
      return () => clearTimeout(timer);
    }
    // Si venimos de una pausa, bloquear avance automático durante 10s
    if (window.__pausaTrasModal) {
      return;
    }
    // Varias imágenes: avanzar normalmente
    if (imgIdx + 1 >= imagenes.length) {
      setFinished(true);
      return;
    }
    const timer = setTimeout(() => {
      setImgIdx(idx => idx + 1);
    }, frameMs);
    return () => clearTimeout(timer);
  }, [imgIdx, frameMs, imagenes.length, datos, loading, finished]);

  // Handlers para salir y confirmar salida
  const handleExit = () => setShowExitConfirm(true);
  const handleConfirmExit = () => {
    setShowExitConfirm(false);
    setFinished(true);
    onNotas && onNotas();
  };

  // Solicitar modo inmersivo (fullscreen + orientación) bajo gesto del usuario
  const [showImmersive, setShowImmersive] = useState(false);
  const requestImmersive = async () => {
    try {
      setShowImmersive(true);
      const el = document.documentElement;
      if (el.requestFullscreen) {
        try { await el.requestFullscreen(); } catch (e) { /* ignore */ }
      } else if (el.webkitRequestFullscreen) {
        try { el.webkitRequestFullscreen(); } catch (e) {}
      } else if (el.mozRequestFullScreen) {
        try { el.mozRequestFullScreen(); } catch (e) {}
      } else if (el.msRequestFullscreen) {
        try { el.msRequestFullscreen(); } catch (e) {}
      }
      // Lock orientation si es posible
      try {
        const isFs = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        if (isFs && window.screen && window.screen.orientation && window.screen.orientation.lock) {
          await window.screen.orientation.lock('landscape');
        }
      } catch (err) {
        console.warn('orientation.lock failed (immersive)', err);
      }
    } catch (_) {}
  };
  const exitImmersive = () => {
    setShowImmersive(false);
    try {
      const isFs = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
      if (isFs) {
        if (document.exitFullscreen) {
          document.exitFullscreen().catch(()=>{});
        } else if (document.webkitExitFullscreen) {
          try { document.webkitExitFullscreen(); } catch {}
        } else if (document.mozCancelFullScreen) {
          try { document.mozCancelFullScreen(); } catch {}
        } else if (document.msExitFullscreen) {
          try { document.msExitFullscreen(); } catch {}
        }
      }
    } catch {}
  };

  // El renderizado condicional va dentro del return, antes del contenido principal
  // Detectar si toca pausa: después de cada serie (última imagen de cada serie)
  const imagenesPorSerie = 7;
  const isPausa = (imgIdx + 1) % imagenesPorSerie === 0 && imgIdx + 1 < imagenes.length;
  // Calcular bloque actual (serie actual)
  const bloqueActual = Math.floor(imgIdx / imagenesPorSerie) + 1;
  // ...existing code...
  return (
    <div className="tratamiento-fullscreen">
      {loading && <div>Cargando tratamiento...</div>}
      {error && <div>Error: {error}</div>}
      {!loading && !error && !datos && <div>No se encontraron datos del tratamiento.</div>}
      {/* Pantalla de finalización visual */}
      {finished && !loading && !error && (
        <div className="tratamiento-modal-overlay">
          <div className="tratamiento-modal-box" ref={el => { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} tabIndex={-1} autoFocus>
            <div className="tratamiento-modal-texto" style={{fontSize:'2rem',fontWeight:700,marginBottom:16}}>¡Tratamiento finalizado!</div>
            <div className="tratamiento-modal-texto" style={{marginBottom:24}}>Has completado todas las imágenes asignadas.<br/>¿Qué deseas hacer ahora?</div>
            <div className="tratamiento-modal-actions">
              <button onClick={() => {
                // Solo llamar a onFinish, no resetear estado local aquí
                onFinish && onFinish();
              }} style={{fontSize:'1.1rem',padding:'10px 24px'}}>Regresar al Menú</button>
              <button onClick={onRelax} style={{fontSize:'1.1rem',padding:'10px 24px'}}>Ir a Relajación Profunda</button>
            </div>
          </div>
        </div>
      )}
      {/* Pantalla de tratamiento normal */}
      {!finished && !loading && !error && datos && (
        <>
          {/* Audio solo si no está en pausa. En bloque 3, usar audio2.mp3 */}
          {!showPauseModal && (
            <audio
              src={
                bloqueActual === 1
                  ? `/Tratamientos/${nombreCarpeta}/audio.mp3`
                  : bloqueActual >= 2 && bloqueActual <= 7
                    ? `/Tratamientos/${nombreCarpeta}/audio${bloqueActual}.mp3`
                    : `/Tratamientos/${nombreCarpeta}/audio.mp3`
              }
              autoPlay
              loop
              className="tratamiento-audio"
            />
          )}
          <div className="tratamiento-btns-fixed">
            {!showImmersive && (
              <button
                className="tratamiento-immersive-btn"
                onClick={requestImmersive}
                aria-label="Activar modo inmersivo"
                title="Activar modo inmersivo"
                style={{
                  padding: '8px 12px',
                  borderRadius: 24,
                  background: 'rgba(0,0,0,0.35)',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.25)',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.25)'
                }}
              >
                VR 180°
              </button>
            )}
            {showImmersive && (
              <button className="tratamiento-immersive-btn" onClick={exitImmersive}>Salir de inmersivo</button>
            )}
            {/* Modo VR eliminado: se optimiza solo 180° visualización */}
            <button className="tratamiento-next-btn" onClick={() => {
              // Calcular la siguiente serie y avanzar al primer elemento del siguiente set
              const serieActual = Math.floor(imgIdx / imagenesPorSerie) + 1;
              const siguienteSerie = serieActual + 1;
              const idxSiguiente = (siguienteSerie - 1) * imagenesPorSerie;
              if (siguienteSerie <= Math.ceil(imagenes.length / imagenesPorSerie)) {
                setImgIdx(idxSiguiente);
                // Limpiar cualquier estado de pausa para permitir avance automático
                window.__pausaTrasModal = false;
              } else {
                // Si no hay más sets, finalizar tratamiento
                setFinished(true);
              }
            }}>
              Siguiente nivel
            </button>
            <button className="tratamiento-exit-btn" onClick={handleExit}>Salir</button>
          </div>
          {/* Imagen de tratamiento o fondo negro */}
          <div className="tratamiento-img-box" style={{ position:'relative' }}>
            {/* Logotema del tratamiento abajo a la izquierda */}
            {logotema && (
              <img src={logotema} alt="Logotema" className="tratamiento-logotema-izq" />
            )}
            {/* Durante la pausa, mostrar pantalla negra y palabra, aunque showImg sea true */}
            {/* En modo inmersivo 180°, aplicamos zoom-out y escala para enfatizar punto de fuga */}
            {showPauseModal ? (
              <div className="tratamiento-black" style={{ background: '#000', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <span className="tratamiento-palabra" style={{ color: '#ff9800', fontSize: '3.2rem', fontWeight: 900, textShadow: '0 4px 16px #000', letterSpacing: 2, textAlign: 'center', width: '100%' }}>
                  {palabrasList[imgIdx] || ''}
                </span>
              </div>
            ) : showImg ? (
              <img
                src={imagenes[imgIdx]}
                alt="Tratamiento"
                className={`tratamiento-img ${showImmersive ? 'immersive-180' : ''}`}
              />
            ) : (
              <div className="tratamiento-black" style={{ background: '#000', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <span className="tratamiento-palabra" style={{ color: '#ff9800', fontSize: '3.2rem', fontWeight: 900, textShadow: '0 4px 16px #000', letterSpacing: 2, textAlign: 'center', width: '100%' }}>
                  {palabrasList[imgIdx] || ''}
                </span>
              </div>
            )}
            {/* GIF EMDR solo si no está en pausa */}
            {!showPauseModal && <img src={emdrGif} alt="EMDR" className="tratamiento-emdr" />}
          </div>
          {/* Modal de pausa después de cada serie */}
          {showPauseModal && (
            <div className="tratamiento-modal-overlay">
              <div className="tratamiento-modal-box" ref={el => { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} tabIndex={-1} autoFocus>
                <div className="tratamiento-modal-texto">¿Deseas continuar con el tratamiento?</div>
                <div className="tratamiento-modal-actions">
                  <button onClick={() => {
                    setShowPauseModal(false);
                    // Limpiar cualquier estado de pausa para permitir avance automático
                    window.__pausaTrasModal = false;
                    // Avanzar a la siguiente imagen, pero si es la última, mostrarla 10s y finalizar
                    const siguienteIdx = imgIdx + 1;
                    const totalImagenes = imagenes.length;
                    const bloqueSiguiente = Math.floor(siguienteIdx / imagenesPorSerie) + 1;
                    if (siguienteIdx >= totalImagenes || bloqueSiguiente > 7) {
                      setFinished(true);
                    } else {
                      setImgIdx(siguienteIdx);
                    }
                  }}>Continuar</button>
                  <button onClick={onRelax}>Relajación Profunda</button>
                  <button onClick={onFinish}>Regresar al Menú</button>
                </div>
              </div>
            </div>
          )}
          {/* Modal de confirmación de salida */}
          {showExitConfirm && (
            <div className="tratamiento-modal-overlay">
              <div className="tratamiento-modal-box" ref={el => { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} tabIndex={-1} autoFocus>
                <div className="tratamiento-modal-texto">¿Seguro que deseas salir? Se guardará tu progreso.</div>
                <div className="tratamiento-modal-actions">
                  <button onClick={() => setShowExitConfirm(false)}>Cancelar</button>
                  <button onClick={onFinish}>Regresar al Menú</button>
                  <button onClick={onRelax}>Salir a Relajación Profunda</button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

